<template>
  <b-card title="User Timeline">
    <app-timeline>

      <app-timeline-item>
        <div class="d-flex flex-sm-row flex-column flex-wrap justify-content-between mb-1 mb-sm-0">
          <h6>12 Redeem to request coupon</h6>
          <small class="text-muted">12 min ago</small>
        </div>
        <p>Starbuck E-Coupon for Amwish Unitech.</p>
        <p class="mb-0">
          <b-img
            :src="require('@/assets/images/icons/jpg.png')"
            height="auto"
            width="20"
            class="mr-1"
          />
          <span class="align-bottom">coupon.jpg</span>
        </p>
      </app-timeline-item>
      <app-timeline-item variant="warning">

        <div class="d-flex flex-sm-row flex-column flex-wrap justify-content-between mb-1 mb-sm-0">
          <h6>Request to refund coupon for client</h6>
          <small class="text-muted">45 min ago</small>
        </div>
        <p>Refund total ฿1,000</p>
        <b-media>
          <template #aside>
            <b-avatar :src="require('@/assets/images/avatars/8-small.png')" />
          </template>
          <h6>Somchai (Client)</h6>
          <p class="mb-0">
            Starbuck
          </p>
        </b-media>
      </app-timeline-item>
      <app-timeline-item
        variant="info"
        title="Create a new summary daily report"
        subtitle="Add files to report folder"
        time="2 days ago"
      />
    </app-timeline>
  </b-card>
</template>

<script>
import {
  BCard, BImg, BMedia, BAvatar,
} from 'bootstrap-vue'
import AppTimeline from '@core/components/app-timeline/AppTimeline.vue'
import AppTimelineItem from '@core/components/app-timeline/AppTimelineItem.vue'

export default {
  components: {
    BCard,
    BImg,
    BMedia,
    BAvatar,
    AppTimeline,
    AppTimelineItem,
  },
}
</script>

<style>

</style>
